/* eslint-disable */
/* Trying to downgrade in the same websocket */
import { VideoStatsEvent } from '../../../logger/types';
import { Logger } from '../../../logger/Logger';

export class VideoControllerV3 {
  public videoVolume = 0.6;

  private path: string = '';
  private streamName?: string;
  private readonly video: HTMLVideoElement;
  private codecString: string = 'video/mp4; codecs="avc1.640028, mp4a.40.2"';
  private mediaSource: MediaSource | null = null;
  private ws: WebSocket | null = null;
  private reconnectingTimer: number | null = null;
  private reconnectingTimerEvery = 10000; // milliseconds
  private inputCode: number | null = null;
  private actionCode: string | null = null;
  private prevActionCode: string | null = null;
  private masterTimer: number | null = null;
  private buffer: SourceBuffer | null = null;
  private minPacketsNeededForBandwidthCalculation: number = 10;
  private bufferInputData: Uint8Array | null = null;
  private bufferBurnRate: number = 0;
  private lastVideoPlaybackRateSnapshot: number = 1;
  private benchmarkBandwidth: number = 0;
  private bandwidthBasedABRInputData: { ts: number; bytes: number }[] = [];
  private lastBandwidthBasedABRChecked: number = Date.now();
  private incorrectCalculatedBandwidthThreshold: number = 10000; // kilo-bits
  private lastCheckToImproveStableUpgrade: number = Date.now();
  private lastCheckToImproveStableUpgradeEvery: number = 5; // seconds
  private upThreshold: number = 5000; // milliseconds
  private clientBandwidth: number = 0;
  private bandwidthAtChannelUpgrade: number[] = [0, 0, 0, 0];
  private lastBufferSnapshot: number = 0;
  private bufferBurnRateThresholdToConsiderForBandwidthBasedUpgrade = 0.05; // percentage
  private bandwidthBasedABRFrequency: number = 3; // seconds
  private leastPacketSizeForBandwidthCalculation = [46080, 19456, 10240, 3072]; // kilo-bits. this is based on the fragDuration set in ffmpeg. Current config is for fragDuration = 100000
  private considerStabilisedinChannelAfter: number = 30; // seconds
  private considerDowngradeStability: number = 40; // seconds
  // private considerDowngradeThresholdForUpgradeIncreaseFactor: number = 6; // seconds
  private bwRateChangeThresholdToConsiderForUpgradeBase: number = 0.3;
  private bwRateChangeThresholdToConsiderForDowngradeBase: number = 0.3;
  private bwRateChangeThresholdToConsiderForUpgradeIncreaseFactor: number = 0.4;
  private bwRateChangeThresholdToConsiderForUpgradeDecreaseFactor: number = 0.4;
  private bwRateChangeThresholdToConsiderForUpgrade: number[] = [
    this.bwRateChangeThresholdToConsiderForUpgradeBase,
    this.bwRateChangeThresholdToConsiderForUpgradeBase,
    this.bwRateChangeThresholdToConsiderForUpgradeBase,
    this.bwRateChangeThresholdToConsiderForUpgradeBase,
  ]; // percentage
  private isPlayerStarted: boolean = false;
  private startUpChannel: number = 2;
  private currentChannel: number = this.startUpChannel;
  private targetChannel: number = 0;
  private bestChannelToPlay: number = -1;
  private hasBeenBestChannelToPlay: boolean[] = [false, false, false, false];
  private queue: Uint8Array[] = [];
  private isAutoChannel: boolean = true;
  private isInitBandWidth: boolean = false;
  private latency: number = 0; // seconds
  private realLatency: number = 0; // seconds
  private packetDuration: number = 40; // milliseconds - this should match with the setting in ffmpeg for frag_duration
  private isChannelChanging: boolean = false;
  private notifyLatencyEvery: number = 3; // seconds
  private latencyUpdatedTime: number = Date.now();
  private pingCounter: number = 0;
  private pingReturnCounter: number = 0;
  private isVideoStopped = false;
  private isVideoPausedinGame: boolean = false;
  private isStageInteraction: boolean = false;
  private isVideoStarted: boolean = false;
  private playbackStartTime: number | null = null;
  private isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  private isVideoStoppedOnMinimize: boolean = false;
  // private unMuteAudioOnplay: boolean = false;
  private pingPongDelay: number = 0;
  private switchClassicviewTimeout?: number; // timeout
  private switchClassicviewTimeoutDuration = 15000; // milliseconds
  private switchClassicView = false;
  // private videoSessionData: string = "0 | 0";
  private lastPacketReceivedAt: number = Date.now();
  private playingInSameChannelSince: (number | null)[] = [null, null, null, null];
  private abrActionMap: Record<number, string> = {
    10: 'DVN',
    11: 'DVN',
    12: 'DVN',
    13: 'RVN',
    20: 'DVS',
    21: 'DVS',
    22: 'DVS',
    23: 'DP',
    30: 'DVS',
    31: 'DVS',
    32: 'DP',
    33: 'DP',
    40: 'DVS',
    41: 'DVS',
    42: 'DP',
    43: 'DP',
    50: 'RP',
    51: 'DP',
    52: 'DP',
    53: 'DP',
    60: 'UP',
    61: 'DP',
    62: 'UVS',
    63: 'UVS',
    70: 'UP',
    71: 'UVS',
    72: 'UVS',
    73: 'UVS',
    80: 'UP',
    81: 'UVS',
    82: 'UVS',
    83: 'UVS',
  };
  private appLaunched: number = Date.now();
  private lastTrimmedLatencyAt: number | null = null;
  private checkNegativeBufferFrequency: number = 500; // milliseconds
  private minMsToPlayToConsiderForNegativeBufferBurn: number = 1000; // milliseconds
  private maxMsToPlayToConsiderForNegativeBufferBurn: number = 10000; // seconds
  private lastNegativeBufferChecked: number | null = null;
  private negativeBufferBurnRateCount: number[] = [0, 0, 0, 0];
  private lastNegativeBufferBurnedAt: number | null = null;
  private negativeBufferBurnedNoDomino: boolean[] = [false, false, false, false];
  private bufferBurnRateThreshold: number = 0.05; // percentage
  private lastImprovedStableUpgrade: number[] = [Date.now(), Date.now(), Date.now(), Date.now()];
  private lastImprovedStableUpgradeThreshold: number = 50;
  private cuvsUpgradeAttemptStart: number = Date.now();
  private lastPingBasedRTTChecked: number = Date.now();
  private prevChannelForCUVS: number = -1;
  private consecutiveUVS: number = 0;
  private startConsecutiveUVS: number = 0; // seconds
  private playbackStartLatency: number = 2.65; // seconds
  private thresholdAbovePBSLForDowngrade: number = 0.45; // seconds
  private thresholdBelowPBSLForDowngrade: number = 10; // seconds
  private playbackOptimalLatencyRange: number[] = [2.2, 2.6]; // seconds
  private minBufferConsiderForBandwidthBasedUpgrade: number = 2.4; // seconds
  private trimCriticalHighLatency: number = 2.6; // seconds
  private criticalQueueHighLatency: number = 8; // seconds
  private considerAsLowEndDeviceBasedOnCriticalQueueLength: number = 50; // size of queue. Each packet in queue is 40 ms if frag_duration is set at 40000 in ffmpeg. So, a value of 50 means a total of 2.00 seconds of playtime in the queue
  private downgradeToleranceForNegativeBufferBurn: number[] = [2.6, 2.3, 2.3, 2.3]; // seconds
  // private highWaitLatency = 2.5; // seconds
  // private highLatency = 3.0; // seconds
  private lowWaitLatency: number = 1.6; // seconds
  private lowLatency: number = 1.2; // seconds
  private criticalLowLatency: number = 0.3; // seconds
  private criticalHighLatency: number = 3.5; // seconds
  private defaultVideoPlaybackRate: number = 1; // seconds
  private videoPlaybackRateChangeFactor: number = 0.05; // seconds
  // private forceStartPlaybackLatency: number = 10000; // milliseconds
  private masterTimerFrequency: number = 300; // milliseconds
  private pingBasedRTTFrequency: number = 5; // seconds
  private minRTTToConsiderForUpgrade: number = 500; // milliseconds
  private firstPingBasedRTTChecked: boolean = false;
  private bufferBasedABRBase: number = 500; // milliseconds
  private latencyByDecreasedPlaybackRate: number[] = [0.0, 0.0, 0.0, 0.0]; // seconds with two decimal precision
  private latencyToleranceForDecreasedPlaybackRate: number = 1000 / this.bufferBasedABRBase; // units of bufferBasedABRBase
  private baseCUVSFactor: number = 6; // seconds
  private consecutiveUVSForUpgrade: number = this.baseCUVSFactor * (1000 / this.bufferBasedABRBase); // seconds
  private cuvsUpgradeThreshold: number = this.baseCUVSFactor * 2; // seconds
  private totalPlaybackTime: number[] = [0, 0, 0, 0]; // milliseconds
  private channelSwitchInCount: number[] = [0, 0, 0, 0]; // int
  private channelUpgradeInSameWSAfterStartCUVSCount: number[] = [0, 0, 1, 0]; // int
  private totPBKTimeSec: number = 0.0; // seconds with two decimal precision
  private currentPBKTime: number = 0.0; // seconds with two decimal precision
  // private upgradeToBadChannelSoftCapCount: number = 1; // int
  private badChannelMinPlaybackPctRequiredForUpgrade: number = 70.0; // percentage
  private lastUpgraded = [null, null, Date.now(), null];
  private goodChannelForUpgrade: boolean[] = [true, true, true, true];
  // private videoSessionStartedAt: number | null = null;
  private lastWssConnectionAttemptedAt: number = Date.now();
  private lastUpdateUpgradeIncreaseFactorChanged: number | null = null;
  private lastUpdateUpgradeIncreaseFactorThreshold: number = 10; // seconds
  // private lastWssReset: number | null = null;
  private lastWssResetForUpgradeCap: number = Date.now();
  private wssResetCount: number = 0;
  private setLastWssResetForUpgradeCapFrequency: number = 2; // not seconds but mod of wssResetCount
  private capUpgradeForWssResetThreshold: number = 20000; // milliseconds
  private hardCapBadChannelForUpgrade: boolean[] = [false, false, false, false];
  private ccuc0fadiswssCount: number = 0;
  private lastC0UpgradeThresholdForC0HardCapCheck: number = 20; // seconds
  private ccuc0fadiswssCountThreshold: number = 2;
  private playingInSameChannelSinceMs: number = 0;
  private lastWssResetForUpgradeCapSec: number = 0;
  private reasonForBadChannelUpgrade: string = '';
  private bandWidthImprovedRecently: boolean = false;
  // private streamName: string = '';
  private isVideoWaiting: boolean = false;
  private isVideoWaitingTime: number | null = null;
  private considerVideoWaitingForDuration: number = 300; // milliseconds
  private reconnectionDuration = 10000; // milliseconds
  private isInitPlaybackStarted: boolean = false;
  private storeVideoStatsInterval: number = 36; // For every 3 mins we need update stats i.e 36 pings * each ping 5sec = 5mins
  private storeVLQ: boolean = false;
  private uuid: string = this.generateUUID();
  private videoErrorCode?: number;
  private statsLogger?: Function;
  private classicViewSwitcher?: Function;
  private latencyListeners: Array<(latency: number) => void> = [];
  private latencyIntervalRef: number | null = null;
  // private uuid: string = this.generateUUID();
  // private frameRateDowngraded: boolean = false;

  public constructor() {
    this.video = document.getElementById('video') as HTMLVideoElement;
  }

  public connectSocket(): void {
    if (this.isVideoPausedinGame) {
      this.isVideoPausedinGame = false;
      this.resetVideoPlayback();
    }
  }

  public closeSocket(): void {
    if (!this.isVideoPausedinGame) {
      this.isVideoPausedinGame = true;
      if (this.video) {
        this.video.pause();
      }
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }

      if (this.masterTimer) {
        clearInterval(this.masterTimer);
        this.masterTimer = null;
      }
    }
  }

  public addLatencyListener(listener: (latency: number) => void): void {
    this.latencyListeners.push(listener);
  }

  ngAfterViewInit(path: string) {
    this.video.controls = false;
    this.video.muted = true;
    this.video.hidden = false;

    if (path) {
      this.path = path;
      this.streamName = this.path.split('/').pop();
      this.streamName = this.streamName?.split('?')[0];
      this.initVideoPlayback();
    } else {
      this.logClientVideoStatsJSON('PE');
    }
    this.addVideoEventListeners();
    this.updateAndNotifyLatency();
  }

  handleVisibilityChange() {
    if (!document.hidden && !this.isVideoPausedinGame) {
      if (this.isMobile && this.isVideoStoppedOnMinimize) {
        this.startVideoOnMaxmize();
      }
      if (this.video.currentTime > 20) {
        var ref = this;
        setTimeout(function () {
          if (!ref.isVideoPlaying()) {
            if (ref.ws) {
              ref.ws.close();
            }
            ref.resetVideoPlayback();
          }
        }, 4000);
      }
    } else if (document.hidden && !this.isVideoPausedinGame) {
      if (this.isMobile && !this.isVideoPausedinGame) {
        this.stopVideoOnMinimize();
      }
    }
  }

  stopVideoOnMinimize() {
    if (this.video) {
      this.video.pause();
    }
    this.resetVideoPlayback();
    this.isVideoStoppedOnMinimize = true;
  }

  startVideoOnMaxmize() {
    this.resetVideoPlayback();
    this.isVideoStoppedOnMinimize = false;
  }

  handleVideoError(e: ErrorEvent) {
    const code = (e.target as HTMLVideoElement).error?.code;
    Logger.logInfo(
      'VideoPlayerLogger',
      'error',
      'Video Error: ' + code + ': ' + (e.target as HTMLVideoElement).error?.message + ', at:' + this.getCurrTime()
    );

    this.logClientVideoStatsJSON('VE');
  }

  calculateClientBandwidth(playingInSameChannelSinceSec: number) {
    if (playingInSameChannelSinceSec <= this.bandwidthBasedABRFrequency) {
      this.clientBandwidth = 0;
      return;
    }
    this.clientBandwidth = 0;
    this.bandwidthBasedABRInputData.forEach((data, index) => {
      let next = this.bandwidthBasedABRInputData[index + 1];
      if (next && next.bytes >= this.leastPacketSizeForBandwidthCalculation[this.currentChannel]) {
        let distance = next.ts - data.ts;
        if (distance > 0) {
          const tempBandwidth = (next.bytes * 8) / distance;
          if (tempBandwidth < this.clientBandwidth || this.clientBandwidth === 0) {
            this.clientBandwidth = tempBandwidth;
          }
        }
      }
      if (this.clientBandwidth >= this.incorrectCalculatedBandwidthThreshold) {
        this.clientBandwidth = 0;
      }
    });
  }

  calculateBenchmarkBandwidth(targetChannel: number) {
    this.targetChannel = targetChannel;
    this.benchmarkBandwidth = 0;
    if (this.hasBeenBestChannelToPlay[this.targetChannel] && this.bandwidthAtChannelUpgrade[this.targetChannel] > 0) {
      this.benchmarkBandwidth = this.bandwidthAtChannelUpgrade[this.targetChannel];
    } else if (this.bandwidthAtChannelUpgrade[this.currentChannel] > 0) {
      let tempvar =
        this.bandwidthAtChannelUpgrade[this.currentChannel] *
        this.bwRateChangeThresholdToConsiderForUpgrade[this.currentChannel];
      this.benchmarkBandwidth = this.bandwidthAtChannelUpgrade[this.currentChannel] + tempvar;
    }
    // console.log("Calc. Bw: " + this.clientBandwidth + ", bbw: " + this.benchmarkBandwidth + ", bbwf: " + bbwCalculatedFrom + ", cuvs: " + this.consecutiveUVS + ", bacupg: " + this.bandwidthAtChannelUpgrade + ", ccnl: " + this.currentChannel + ", piscs: " + playingInSameChannelSinceSec + ", buf: " + this.latency + ", bctp: " + this.bestChannelToPlay + ", cusc: " + this.channelUpgradeInSameWSAfterStartCUVSCount + ", brcttcfu: " + this.bwRateChangeThresholdToConsiderForUpgrade + ", bbr: " + this.bufferBurnRate + ", at: " + this.getCurrTime());
    Logger.logInfo(
      'VideoPlayerLogger',
      'error',
      'Calc. Bw: ' +
        this.clientBandwidth +
        ', bbw: ' +
        this.benchmarkBandwidth +
        ', cuvs: ' +
        this.consecutiveUVS +
        ', bacupg: ' +
        this.bandwidthAtChannelUpgrade +
        ', ccnl: ' +
        this.currentChannel +
        ', buf: ' +
        this.latency +
        ', bctp: ' +
        this.bestChannelToPlay +
        ', cusc: ' +
        this.channelUpgradeInSameWSAfterStartCUVSCount +
        ', brcttcfu: ' +
        this.bwRateChangeThresholdToConsiderForUpgrade +
        ', bbr: ' +
        this.bufferBurnRate +
        ', at: ' +
        this.getCurrTime()
    );
  }

  decideBestChannelToPlay(playingInSameChannelSinceSec: number) {
    if (
      playingInSameChannelSinceSec >= this.considerStabilisedinChannelAfter &&
      this.latency >= this.minBufferConsiderForBandwidthBasedUpgrade &&
      this.bufferBurnRate < this.bufferBurnRateThresholdToConsiderForBandwidthBasedUpgrade
    ) {
      if (this.bestChannelToPlay !== this.currentChannel) {
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Setting best channel to play as channel: ' + this.currentChannel + ', at: ' + this.getCurrTime()
        );
        this.bestChannelToPlay = this.currentChannel;
        // send event to stats service
        this.logClientVideoStatsJSON('SC');
      }
      this.hasBeenBestChannelToPlay[this.currentChannel] = true;
    }
  }

  decideForChannelUpgrade(targetChannel: number) {
    this.targetChannel = targetChannel;
    let downgradeTolerance: number;
    if (this.currentChannel < 3) {
      downgradeTolerance = this.downgradeToleranceForNegativeBufferBurn[this.currentChannel + 1];
    } else {
      downgradeTolerance = this.downgradeToleranceForNegativeBufferBurn[this.currentChannel];
    }
    if (
      this.benchmarkBandwidth > 0 &&
      this.clientBandwidth >= this.benchmarkBandwidth &&
      this.currentChannel > 0 &&
      this.latency >= downgradeTolerance &&
      this.bufferBurnRate < this.bufferBurnRateThresholdToConsiderForBandwidthBasedUpgrade
    ) {
      if (
        (!this.hasBeenBestChannelToPlay[this.targetChannel] &&
          this.bwRateChangeThresholdToConsiderForUpgrade[this.currentChannel] <
            this.bwRateChangeThresholdToConsiderForUpgradeBase +
              this.bwRateChangeThresholdToConsiderForUpgradeIncreaseFactor * 2) ||
        this.hasBeenBestChannelToPlay[this.targetChannel]
      ) {
        if (this.video.playbackRate >= 1) {
          this.adjustVideoPlayback(this.videoPlaybackRateChangeFactor, -1);
        }
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Bandwidth improved. Upgrading channel from: ' +
            this.currentChannel +
            ' to: ' +
            this.targetChannel +
            ', pbkrt: ' +
            this.video.playbackRate +
            ', at: ' +
            this.getCurrTime()
        );
        if (!this.bandWidthImprovedRecently) {
          // send event to stats service
          this.logClientVideoStatsJSON('BI');
          this.bandWidthImprovedRecently = true;
        }
        for (let i = this.targetChannel; i >= 0; i--) {
          this.goodChannelForUpgrade[i] = true;
        }
        this.adaptBitrate(true, this.targetChannel, true);
      }
    }
  }

  decideBandwidthAtChannelUpgrade(targetChannel: number, playingInSameChannelSinceSec: number) {
    this.targetChannel = targetChannel;
    if (this.bandwidthAtChannelUpgrade[this.currentChannel] === 0 && playingInSameChannelSinceSec >= 5) {
      this.bandwidthAtChannelUpgrade[this.currentChannel] = this.clientBandwidth;
    } else if (
      this.clientBandwidth < this.bandwidthAtChannelUpgrade[this.currentChannel] &&
      playingInSameChannelSinceSec >= 5 &&
      !this.hasBeenBestChannelToPlay[this.currentChannel]
    ) {
      this.bandwidthAtChannelUpgrade[this.currentChannel] = this.clientBandwidth;
    }
    if (
      this.currentChannel > 0 &&
      this.benchmarkBandwidth > this.bandwidthAtChannelUpgrade[this.targetChannel] &&
      this.bandwidthAtChannelUpgrade[this.targetChannel] > 0 &&
      !this.hasBeenBestChannelToPlay[this.targetChannel]
    ) {
      this.bandwidthAtChannelUpgrade[this.targetChannel] = this.benchmarkBandwidth;
    }
  }

  bandwidthBasedABR() {
    let currentTime = Date.now();
    if (this.bandwidthBasedABRInputData.length < this.minPacketsNeededForBandwidthCalculation) {
      return;
    }
    let playingInSameChannelSinceSec = 0;
    let playingInSameChannelSinceElement = this.playingInSameChannelSince[this.currentChannel];
    if (playingInSameChannelSinceElement) {
      playingInSameChannelSinceSec = (currentTime - playingInSameChannelSinceElement) / 1000.0;
    }

    this.calculateClientBandwidth(playingInSameChannelSinceSec);
    if (this.clientBandwidth <= 0) {
      return;
    }
    this.decideBestChannelToPlay(playingInSameChannelSinceSec);
    this.targetChannel = 0;
    if (this.currentChannel > 0) {
      this.targetChannel = this.currentChannel - 1;
    }
    this.calculateBenchmarkBandwidth(this.targetChannel);
    this.decideBandwidthAtChannelUpgrade(this.targetChannel, playingInSameChannelSinceSec);
    this.decideForChannelUpgrade(this.targetChannel);
  }

  resetBandwidth() {
    this.bandwidthBasedABRInputData = [];
    this.lastBandwidthBasedABRChecked = Date.now();
  }

  checkAndSetQueueBasedChannelUpgradeHardCap() {
    let appLaunchedSinceSec = (Date.now() - this.appLaunched) / 1000.0;
    if (
      this.queue.length > this.considerAsLowEndDeviceBasedOnCriticalQueueLength &&
      appLaunchedSinceSec <= 30 &&
      !this.hardCapBadChannelForUpgrade[2]
    ) {
      this.hardCapBadChannelForUpgrade[0] = true;
      this.hardCapBadChannelForUpgrade[1] = true;
      this.hardCapBadChannelForUpgrade[2] = true;
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'At checkAndSetQueueBasedChannelUpgradeHardCap, setting hcbcfupg: ' +
          this.hardCapBadChannelForUpgrade +
          ', ql: ' +
          this.queue.length +
          ', wrc: ' +
          this.wssResetCount +
          ', lwrfucs: ' +
          this.lastWssResetForUpgradeCapSec +
          ', tpbktbyc: ' +
          this.totalPlaybackTime +
          ', csic: ' +
          this.channelSwitchInCount +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
      // send event to UI to mark as low-end device
      this.logClientVideoStatsJSON('QH');
      return true;
    }
    return false;
  }

  checkForLatencyByDecreasedPlaybackRate() {
    this.latencyByDecreasedPlaybackRate[this.currentChannel] =
      this.defaultVideoPlaybackRate -
      this.video.playbackRate +
      this.latencyByDecreasedPlaybackRate[this.currentChannel];
    if (this.latencyByDecreasedPlaybackRate[this.currentChannel] >= this.latencyToleranceForDecreasedPlaybackRate) {
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Latency exceeded 1 sec because of decreased playback. Increasing playback rate at: ' + this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('LE');
      let vidPlaybackRateChangeFactor = this.videoPlaybackRateChangeFactor;
      if (this.video.playbackRate < 1) {
        vidPlaybackRateChangeFactor = this.videoPlaybackRateChangeFactor * 2;
      }
      this.adjustVideoPlayback(vidPlaybackRateChangeFactor, 1);
    }
  }

  checkForNegativeBufferBurnRate(currentTime: number) {
    // @ts-ignore
    this.playingInSameChannelSinceMs = currentTime - this.playingInSameChannelSince[this.currentChannel];
    let lastTrimmedLatency = 0;
    if (this.lastTrimmedLatencyAt !== null) {
      lastTrimmedLatency = (currentTime - this.lastTrimmedLatencyAt) / 1000.0;
    }

    let bufferBurnRateCheck = 0;
    if (this.lastNegativeBufferChecked) {
      bufferBurnRateCheck = currentTime - this.lastNegativeBufferChecked;
    } else {
      this.lastNegativeBufferChecked = currentTime;
    }

    let lastNegativeBufferBurned = 0;
    if (this.lastNegativeBufferBurnedAt !== null) {
      lastNegativeBufferBurned = (currentTime - this.lastNegativeBufferBurnedAt) / 1000.0;
    }

    if (bufferBurnRateCheck >= this.checkNegativeBufferFrequency) {
      if (this.lastBufferSnapshot > 0) {
        this.bufferBurnRate = ((this.lastBufferSnapshot - this.latency) / this.lastBufferSnapshot) * 1000;
      }
      this.bufferBurnRate = this.bufferBurnRate / bufferBurnRateCheck;
      this.bufferBurnRate = parseFloat(this.bufferBurnRate.toFixed(2));
      if (
        this.playingInSameChannelSinceMs < this.minMsToPlayToConsiderForNegativeBufferBurn ||
        (lastNegativeBufferBurned > 0 && lastNegativeBufferBurned <= 3.5) ||
        (this.lastVideoPlaybackRateSnapshot < 1 && this.video.playbackRate < 1)
      ) {
        this.bufferBurnRate = 0;
      }
      this.lastVideoPlaybackRateSnapshot = this.video.playbackRate;
      this.lastBufferSnapshot = this.latency;
      this.lastNegativeBufferChecked = currentTime;
    }

    let secSinceLastUpgradedOfHigherChannel = 0;
    if (this.currentChannel > 0 && this.lastUpgraded[this.currentChannel - 1] !== null) {
      // @ts-ignore
      secSinceLastUpgradedOfHigherChannel = (currentTime - this.lastUpgraded[this.currentChannel - 1]) / 1000.0;
    }
    if (
      this.playingInSameChannelSinceMs >= this.minMsToPlayToConsiderForNegativeBufferBurn &&
      this.playingInSameChannelSinceMs <= this.maxMsToPlayToConsiderForNegativeBufferBurn &&
      (lastNegativeBufferBurned === 0 || lastNegativeBufferBurned > 3.5) &&
      this.lastBufferSnapshot > 0 &&
      this.bufferBurnRate >= this.bufferBurnRateThreshold &&
      this.currentChannel < 3 &&
      this.video.playbackRate <= 1 &&
      (lastTrimmedLatency === 0 || lastTrimmedLatency >= 1.5) &&
      this.latency <= this.downgradeToleranceForNegativeBufferBurn[this.currentChannel]
    ) {
      this.negativeBufferBurnRateCount[this.currentChannel] = this.negativeBufferBurnRateCount[this.currentChannel] + 1;
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Negative buffer burn rate. Downgrading video in same websocket, curr. chnl: ' +
          this.currentChannel +
          ', bbr: ' +
          this.bufferBurnRate +
          ', bbrt: ' +
          this.bufferBurnRateThreshold +
          ', pbkrt: ' +
          this.video.playbackRate +
          ', ltl: ' +
          lastTrimmedLatency +
          ', buf: ' +
          this.latency +
          ', piscs: ' +
          this.playingInSameChannelSinceMs +
          ', lnbb: ' +
          lastNegativeBufferBurned +
          ', ssluohc: ' +
          secSinceLastUpgradedOfHigherChannel +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('NB');
      if (
        (lastNegativeBufferBurned === 0 || lastNegativeBufferBurned > 3) &&
        (secSinceLastUpgradedOfHigherChannel === 0 || secSinceLastUpgradedOfHigherChannel > 6) &&
        (lastTrimmedLatency === 0 || lastTrimmedLatency > 7) &&
        this.playingInSameChannelSinceMs <= this.considerStabilisedinChannelAfter
      ) {
        this.negativeBufferBurnedNoDomino[this.currentChannel] = true;
      }
      this.lastNegativeBufferBurnedAt = currentTime;
      this.targetChannel = this.currentChannel + 1;
      this.adaptBitrate(true, this.targetChannel, true);
      this.bufferBurnRate = 0;
      return;
    }
  }

  checkBufferBasedABR() {
    if (this.isVideoPlaying()) {
      let currentTime = Date.now();
      // @ts-ignore
      this.playingInSameChannelSinceMs = currentTime - this.playingInSameChannelSince[this.currentChannel];

      this.checkForLatencyByDecreasedPlaybackRate();

      this.checkForNegativeBufferBurnRate(currentTime);

      const latencyRange = this.getLatencyRange(this.latency);
      this.inputCode = latencyRange * 10 + this.currentChannel;
      this.actionCode = this.abrActionMap[this.inputCode];
      // @ts-ignore
      this.currentPBKTime = currentTime - this.playingInSameChannelSince[this.currentChannel];
      this.totPBKTimeSec =
        (this.totalPlaybackTime[0] +
          this.totalPlaybackTime[1] +
          this.totalPlaybackTime[2] +
          this.totalPlaybackTime[3] +
          this.currentPBKTime) /
        1000.0;

      // console.log("ipc:" + this.inputCode + ", ac:" + this.actionCode + ", ccnl:" + this.currentChannel + ", cuvs:" + this.consecutiveUVS + ", buf:" + this.latency + ", rl: " + this.realLatency + ", ql: " + this.queue.length + ", pbkrt:" + this.video.playbackRate + ", cusc:" + this.channelUpgradeInSameWSAfterStartCUVSCount + ", csic: " + this.channelSwitchInCount + ", tbktbyc:" + this.totalPlaybackTime + ", tpbkt:" + this.totPBKTimeSec + ", pinscsms: " + this.playingInSameChannelSinceMs + ", bctp: " + this.bestChannelToPlay + ", gcfu: " + this.goodChannelForUpgrade + ", hbbctp: " + this.hasBeenBestChannelToPlay + ", bw: " + this.clientBandwidth + ", bacupg: " + this.bandwidthAtChannelUpgrade + ", wrc: " + this.wssResetCount + ", hcbcfupg: "+ this.hardCapBadChannelForUpgrade + ", brcttcfu: " + this.bwRateChangeThresholdToConsiderForUpgrade + ", bbr: " + this.bufferBurnRate + ", nbbrc: " + this.negativeBufferBurnRateCount + ", lbdpbrt: " + this.latencyByDecreasedPlaybackRate + ", at:" + this.getCurrTime());
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'ipc:' +
          this.inputCode +
          ', ac:' +
          this.actionCode +
          ', ccnl:' +
          this.currentChannel +
          ', cuvs:' +
          this.consecutiveUVS +
          ', buf:' +
          this.latency +
          ', rl: ' +
          this.realLatency +
          ', ql: ' +
          this.queue.length +
          ', pbkrt:' +
          this.video.playbackRate +
          ', cusc:' +
          this.channelUpgradeInSameWSAfterStartCUVSCount +
          ', csic: ' +
          this.channelSwitchInCount +
          ', tbktbyc:' +
          this.totalPlaybackTime +
          ', pinscsms: ' +
          this.playingInSameChannelSinceMs +
          ', bctp: ' +
          this.bestChannelToPlay +
          ', gcfu: ' +
          this.goodChannelForUpgrade +
          ', hbbctp: ' +
          this.hasBeenBestChannelToPlay +
          ', bw: ' +
          this.clientBandwidth +
          ', bacupg: ' +
          this.bandwidthAtChannelUpgrade +
          ', wrc: ' +
          this.wssResetCount +
          ', hcbcfupg: ' +
          this.hardCapBadChannelForUpgrade +
          ', brcttcfu: ' +
          this.bwRateChangeThresholdToConsiderForUpgrade +
          ', bbr: ' +
          this.bufferBurnRate +
          ', nbbrc: ' +
          this.negativeBufferBurnRateCount +
          ', lbdpbrt: ' +
          this.latencyByDecreasedPlaybackRate +
          ', at:' +
          this.getCurrTime()
      );
      // send event to stats service
      if (this.prevActionCode) {
        if (this.prevActionCode !== this.actionCode && this.actionCode == 'RP') {
          this.logClientVideoStatsJSON(this.actionCode);
          this.prevActionCode = this.actionCode;
        }
      } else if (this.actionCode == 'RP') {
        this.logClientVideoStatsJSON(this.actionCode);
        this.prevActionCode = this.actionCode;
      }
      switch (this.actionCode) {
        case 'RP':
          this.fineTunePlayBackRate(this.videoPlaybackRateChangeFactor);
          this.consecutiveUVS = 0;
          break;
        case 'DVS':
          if (this.video.playbackRate > this.defaultVideoPlaybackRate) {
            this.adjustVideoPlayback(this.defaultVideoPlaybackRate, 0);
          }
          if (this.currentChannel !== this.bestChannelToPlay || this.latency <= this.lowWaitLatency) {
            this.adaptBitrate(true, this.currentChannel + 1, false);
            this.consecutiveUVS = 0;
          }
          break;
        case 'UVS':
          if (this.latency > 3) {
            this.adjustVideoPlayback(this.videoPlaybackRateChangeFactor, 1);
          } else {
            this.adjustVideoPlayback(this.videoPlaybackRateChangeFactor / 2, -1);
          }
          this.consecutiveUVS++;
          if (this.consecutiveUVS === 1 && this.currentChannel !== this.prevChannelForCUVS) {
            Logger.logInfo(
              'VideoPlayerLogger',
              'error',
              'Setting cuvsUpgradeAttemptStart to: ' +
                this.getCurrTime() +
                ', ccnl:' +
                this.currentChannel +
                ', pccuvs: ' +
                this.prevChannelForCUVS +
                ', at: ' +
                this.getCurrTime()
            );
            // send event to stats service
            this.cuvsUpgradeAttemptStart = currentTime;
            this.prevChannelForCUVS = this.currentChannel;
          }
          this.adaptBitrate(true, this.currentChannel - 1, false);
          break;
        case 'DVN':
          if (this.currentChannel < 2 && !this.hardCapBadChannelForUpgrade[2]) {
            this.adaptBitrate(false, 2, false);
          } else {
            this.adaptBitrate(false, 3, false);
          }
          this.consecutiveUVS = 0;
          break;
        case 'RVN':
          this.adaptBitrate(false, this.currentChannel, false);
          this.consecutiveUVS = 0;
          break;
        case 'UP':
          if (this.playingInSameChannelSinceMs >= this.upThreshold) {
            this.adjustVideoPlayback(this.videoPlaybackRateChangeFactor, 1);
          } else {
            this.adjustVideoPlayback(this.defaultVideoPlaybackRate, 0);
          }
          this.consecutiveUVS = 0;
          break;
        case 'DP':
          if (
            this.latencyByDecreasedPlaybackRate[this.currentChannel] < this.latencyToleranceForDecreasedPlaybackRate
          ) {
            this.adjustVideoPlayback(this.videoPlaybackRateChangeFactor, -1);
          }
          this.consecutiveUVS = 0;
          break;
        default:
          this.consecutiveUVS = 0;
          break;
      }

      this.checkToImproveStableUpgrade();
    }
  }

  checkToImproveStableUpgrade() {
    let lastCheckToImproveStableUpgradeSec = (Date.now() - this.lastCheckToImproveStableUpgrade) / 1000.0;
    let lastImprovedStableUpgradeSec = (Date.now() - this.lastImprovedStableUpgrade[this.currentChannel]) / 1000.0;
    if (lastCheckToImproveStableUpgradeSec >= this.lastCheckToImproveStableUpgradeEvery) {
      if (
        this.currentChannel > 0 &&
        this.currentChannel === this.bestChannelToPlay &&
        this.hasBeenBestChannelToPlay[this.currentChannel] &&
        lastImprovedStableUpgradeSec > this.lastImprovedStableUpgradeThreshold
      ) {
        this.targetChannel = this.currentChannel - 1;

        let secsinCurrentChannel = 0;
        let playingInSameChannelSinceElement = this.playingInSameChannelSince[this.currentChannel];
        if (playingInSameChannelSinceElement !== null) {
          secsinCurrentChannel = (Date.now() - playingInSameChannelSinceElement) / 1000.0;
        }

        if (
          secsinCurrentChannel > this.considerDowngradeStability &&
          !this.hasBeenBestChannelToPlay[this.targetChannel] &&
          this.bwRateChangeThresholdToConsiderForUpgrade[this.currentChannel] >
            this.bwRateChangeThresholdToConsiderForDowngradeBase
        ) {
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Decreasing brcttcfu for channel: ' +
              this.currentChannel +
              ', lisus: ' +
              lastImprovedStableUpgradeSec +
              ', sicc: ' +
              secsinCurrentChannel +
              ', at: ' +
              this.getCurrTime()
          );
          // send event to stats service
          this.logClientVideoStatsJSON('DB');
          this.bwRateChangeThresholdToConsiderForUpgrade[this.currentChannel] =
            this.bwRateChangeThresholdToConsiderForUpgrade[this.currentChannel] -
            this.bwRateChangeThresholdToConsiderForUpgradeDecreaseFactor;
        } else if (
          secsinCurrentChannel > this.considerDowngradeStability &&
          this.hasBeenBestChannelToPlay[this.targetChannel] &&
          this.bandwidthAtChannelUpgrade[this.targetChannel] > this.bandwidthAtChannelUpgrade[this.currentChannel] &&
          this.bandwidthAtChannelUpgrade[this.targetChannel] >
            this.bandwidthAtChannelUpgrade[this.targetChannel] -
              this.bandwidthAtChannelUpgrade[this.targetChannel] *
                this.bwRateChangeThresholdToConsiderForUpgradeDecreaseFactor
        ) {
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Decreasing bacupg for channel: ' +
              this.targetChannel +
              ', lisus: ' +
              lastImprovedStableUpgradeSec +
              ', sicc: ' +
              secsinCurrentChannel +
              ', at: ' +
              this.getCurrTime()
          );
          // send event to stats service
          this.logClientVideoStatsJSON('DU');
          this.bandwidthAtChannelUpgrade[this.targetChannel] =
            this.bandwidthAtChannelUpgrade[this.targetChannel] -
            this.bandwidthAtChannelUpgrade[this.targetChannel] *
              this.bwRateChangeThresholdToConsiderForUpgradeDecreaseFactor;
        }
        this.lastCheckToImproveStableUpgrade = Date.now();
        this.lastImprovedStableUpgrade[this.currentChannel] = Date.now();
      }
    }
  }

  adjustVideoPlayback(videoPlaybackRateChangeFactor: number, direction: number) {
    if (direction === -1) {
      // Decrease playback rate
      if (
        this.currentChannel !== this.bestChannelToPlay ||
        (this.currentChannel > 0 && this.goodChannelForUpgrade[this.currentChannel - 1])
      ) {
        this.video.playbackRate = this.defaultVideoPlaybackRate - videoPlaybackRateChangeFactor;
      } else if (this.currentChannel > 0 && !this.goodChannelForUpgrade[this.currentChannel - 1]) {
        this.fineTunePlayBackRate(videoPlaybackRateChangeFactor);
      }
    } else if (direction === 0) {
      // Reset playback rate to normal
      this.video.playbackRate = this.defaultVideoPlaybackRate;
    } else if (direction === 1) {
      // Increase playback rate
      if (
        this.currentChannel === 0 ||
        (this.currentChannel > 0 && this.goodChannelForUpgrade[this.currentChannel - 1])
      ) {
        this.video.playbackRate = this.defaultVideoPlaybackRate + videoPlaybackRateChangeFactor;
      } else if (this.currentChannel > 0 && !this.goodChannelForUpgrade[this.currentChannel - 1]) {
        this.fineTunePlayBackRate(videoPlaybackRateChangeFactor);
      }
      this.video.playbackRate = this.defaultVideoPlaybackRate + videoPlaybackRateChangeFactor;
    } else {
      Logger.logInfo('VideoPlayerLogger', 'error', 'No valid direction passed in input');
      // send event to stats service
      this.logClientVideoStatsJSON('ID');
    }
  }

  checkBandwidthBasedABR() {
    if (!this.isChannelChanging) {
      let lastBandwidthBasedABRCheckedSec = (Date.now() - this.lastBandwidthBasedABRChecked) / 1000.0;
      if (lastBandwidthBasedABRCheckedSec >= this.bandwidthBasedABRFrequency) {
        this.bandwidthBasedABR();
        this.resetBandwidth();
      }
    }
  }

  checkPingBasedRTT() {
    let currentTime = Date.now();
    let lastPingBasedRTTCheckedSec = (currentTime - this.lastPingBasedRTTChecked) / 1000.0;
    // let appLaunchedSinceSec = (currentTime - this.appLaunched) / 1000.00;
    if (lastPingBasedRTTCheckedSec >= this.pingBasedRTTFrequency || !this.firstPingBasedRTTChecked) {
      this.pingCounter++;
      var msg = {
        cmd: 'ping',
        counter: this.pingCounter,
        clientTime: currentTime,
      };

      if (this.storeVLQ) {
        if (
          this.isAutoChannel &&
          this.pingCounter > 0 &&
          (this.pingCounter % this.storeVideoStatsInterval === 0 ||
            this.pingCounter === this.storeVideoStatsInterval / 5)
        ) {
          this.storePlayerDetails();
        }
      }

      if (this.ws?.readyState == WebSocket.OPEN) {
        this.ws.send(JSON.stringify(msg));
        this.lastPingBasedRTTChecked = currentTime;
        this.firstPingBasedRTTChecked = true;
      }
    }
  }

  detectNetworkChange() {
    if (!this.isVideoPausedinGame && Date.now() - this.lastPacketReceivedAt >= this.reconnectionDuration) {
      this.resetVideoPlayback();
    }
  }

  prepareMediaSource() {
    this.mediaSource = new MediaSource();
    this.mediaSource.addEventListener('sourceopen', this.sourceBufferHandle.bind(this));
    this.mediaSource.addEventListener('sourceended', this.onSourceEnded.bind(this));
    this.mediaSource.addEventListener('sourceclose', this.onSourceClose.bind(this));
    this.mediaSource.addEventListener('sourcebuffererror', this.onSourceBufferError.bind(this));
    this.video.src = this.createObjectURL(this.mediaSource);
    this.video.addEventListener('error', this.handleVideoError.bind(this));
  }

  initWebsocketPlayer() {
    // this.videoSessionStartedAt = Date.now();
    if ('MediaSource' in window && MediaSource.isTypeSupported(this.codecString)) {
      this.prepareMediaSource();
    } else {
      this.logClientVideoStatsJSON('UM');
    }

    this.masterTimer && window.clearInterval(this.masterTimer);
    this.masterTimer = window.setInterval((): void => {
      if (this.isAutoChannel && this.isInitPlaybackStarted) {
        this.checkBufferBasedABR();
        this.checkBandwidthBasedABR();
      }
      this.checkPingBasedRTT();
      this.detectNetworkChange();
    }, this.masterTimerFrequency);
    this.decideClassicViewSwitch();
  }

  checkLowBandwidthForPopup() {
    if (!this.isAutoChannel) {
      ////console.log('Here throw a pop-up that not sufficient bandwidth....and switching to Auto',this.currentChannel,channel);
      this.isAutoChannel = true;
      // window.parent.window.postMessage({ "type": "LOW_BANDWIDTH" }, "*");
    }
  }

  addVideoEventListeners() {
    if (!this.video) {
      return;
    }

    var visibilityChange;
    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      visibilityChange = 'visibilitychange';
    }

    /* @ts-ignore */
    if (typeof document['msHidden'] !== 'undefined') {
      visibilityChange = 'msvisibilitychange';
    }

    /* @ts-ignore */
    if (typeof document['webkitHidden'] !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange';
    }

    // Handle page visibility change
    visibilityChange && document.addEventListener(visibilityChange, this.handleVisibilityChange.bind(this));

    var ref = this;
    this.video.addEventListener('waiting', function () {
      ref.playVideo();
      if (!ref.video || ref.isVideoPausedinGame) {
        return;
      }
      if (
        ref.latency >= ref.criticalLowLatency &&
        ref.video.seekable.length > 0 &&
        ref.video.readyState > 0 &&
        !ref.isVideoPlaying()
      ) {
        ref.setVideoCurrentTime(ref.video.currentTime + 0.1);
        ref.latency = ref.latency - 0.1;
        ref.playVideo();
        let videoWaitingTimeMs = 0;
        if (ref.isVideoWaitingTime !== null) {
          videoWaitingTimeMs = Date.now() - ref.isVideoWaitingTime;
        }
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'In waiting, video is capable of playing, buf: ' +
            ref.latency +
            ', vwtms: ' +
            videoWaitingTimeMs +
            ', at: ' +
            ref.getCurrTime()
        );
        if (ref.isVideoWaiting && ref.isVideoWaitingTime && videoWaitingTimeMs > ref.considerVideoWaitingForDuration) {
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Video waiting for more than threshold, vwtms: ' + videoWaitingTimeMs + ', at: ' + ref.getCurrTime()
          );
          // send event to stats service
          if (ref.latency >= ref.trimCriticalHighLatency && ref.video.seekable.length > 0) {
            ref.setVideoCurrentTime(ref.video.seekable.end(0) - ref.trimCriticalHighLatency);
            ref.latency = ref.trimCriticalHighLatency;
            ref.playVideo();
            ref.lastTrimmedLatencyAt = Date.now();
          }
        }
        ref.isVideoWaitingTime = Date.now();
        ref.isVideoWaiting = true;
      } else {
        if (ref.video.seekable.length > 0) {
          ref.latency = parseFloat((ref.video.seekable.end(0) - ref.video.currentTime).toFixed(2));
        } else {
          ref.latency = 0.01;
        }
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'In waiting, video is incapable of playing, re-connecting in new websocket buf: ' +
            ref.latency +
            ' at: ' +
            ref.getCurrTime()
        );
        ref.checkAndSetQueueBasedChannelUpgradeHardCap();
        if (ref.queue.length < 10) {
          if (ref.currentChannel < 2 && !ref.hardCapBadChannelForUpgrade[2]) {
            ref.adaptBitrate(false, 2, false);
          } else {
            ref.adaptBitrate(false, 3, false);
          }
        }
        ref.consecutiveUVS = 0;
      }
    });

    this.video.addEventListener('playing', function () {
      if (!ref.video || ref.isVideoPausedinGame) {
        return;
      }
      if (ref.video.seekable.length > 0) {
        ref.latency = parseFloat((ref.video.seekable.end(0) - ref.video.currentTime).toFixed(2));
      } else {
        ref.latency = 0.1;
      }
      if (ref.isVideoWaiting) {
        ref.isVideoWaiting = false;
        ref.isVideoWaitingTime = null;
      }

      if (!ref.isInitPlaybackStarted) {
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Started to play video, buf: ' + ref.latency + ', ql: ' + ref.queue.length + ', at: ' + ref.getCurrTime()
        );
        // send event to stats service
        ref.isInitPlaybackStarted = true;
      }
    });

    this.video.addEventListener('error', function () {
      if (!ref.video || ref.isVideoPausedinGame) return;
      ////console.log("Error " + ref.video.error.code + "; details: " + ref.video.error.message);
      // send event to stats service
      ref.logClientVideoStatsJSON('VE');
      ref.resetBandwidth();
      if (ref.mediaSource?.readyState === 'open') {
        ref.buffer?.abort();
      }
      ref.clearMediaSourceEventListeners();
      ref.resetVideoPlayback();
    });

    this.video.addEventListener('seeked', function () {
      if (!ref.video || ref.isVideoPausedinGame) return;
    });

    this.video.addEventListener('seeking', function () {
      if (!ref.video || ref.isVideoPausedinGame) return;
    });

    this.video.addEventListener('stalled', function () {
      if (!ref.video || ref.isVideoPausedinGame) return;
      Logger.logInfo('VideoPlayerLogger', 'error', 'Video is stalled, at: ' + ref.getCurrTime());
    });

    this.video.addEventListener('suspend', function () {
      if (!ref.video || ref.isVideoPausedinGame) return;
      Logger.logInfo('VideoPlayerLogger', 'error', 'Video is suspended, at: ' + ref.getCurrTime());
    });

    window.addEventListener('beforeunload', function () {
      if (ref.ws) {
        ref.ws.close();
        ref.ws = null;
      }
    });

    window.addEventListener(
      'mousedown',
      function () {
        ref.onStageTouch();
      }.bind(ref)
    );

    window.addEventListener(
      'touchstart',
      function () {
        ref.onStageTouch();
      }.bind(ref)
    ); // for mobile
  }

  onStageTouch() {
    if (this.video) {
      this.isStageInteraction = true;
      if (this.video.muted && this.videoVolume > 0) {
        this.video.muted = false;
      }
      if (this.video.paused && !this.isVideoPlaying() && this.isInitBandWidth) {
        if (this.video.seekable.length > 0) {
          if (this.video.seekable.end(0) >= this.playbackStartLatency && !this.isVideoPausedinGame) {
            this.playVideo();
            this.playingInSameChannelSince[this.currentChannel] = Date.now();
          }
        }
      }
    }
  }

  sourceBufferHandle() {
    var ref = this;
    if (this.mediaSource?.readyState === 'open') {
      if (!this.ws) {
        this.initWS();
      }
      this.logClientVideoStatsJSON('MO');
      this.buffer = this.mediaSource.addSourceBuffer(this.codecString);
      this.buffer.mode = 'sequence';
      this.buffer.addEventListener('updateend', function () {
        ref.updateBuffer();
        if (ref.video.seekable.length > 0) {
          if (ref.video.seekable.end(0) >= 5.0 && ref.video.currentTime === 0) {
            ref.setVideoCurrentTime(ref.video.seekable.end(0) - 1);
          }
        }
        if (!ref.isVideoPlaying()) {
          if (ref.video.seekable.length > 0) {
            if (ref.video.seekable.end(0) >= ref.playbackStartLatency) {
              if (ref.video.paused) {
                let playingInSameChannelSinceSec =
                  // @ts-ignore
                  (Date.now() - ref.playingInSameChannelSince[ref.currentChannel]) / 1000.0;
                if (
                  ref.currentChannel === ref.startUpChannel &&
                  ref.currentChannel < 3 &&
                  ref.channelUpgradeInSameWSAfterStartCUVSCount[0] === 0 &&
                  ref.channelUpgradeInSameWSAfterStartCUVSCount[1] === 0 &&
                  ref.channelUpgradeInSameWSAfterStartCUVSCount[2] === 1 &&
                  ref.channelUpgradeInSameWSAfterStartCUVSCount[3] === 0 &&
                  playingInSameChannelSinceSec >= ref.playbackStartLatency + ref.thresholdAbovePBSLForDowngrade &&
                  playingInSameChannelSinceSec < ref.thresholdBelowPBSLForDowngrade
                ) {
                  Logger.logInfo(
                    'VideoPlayerLogger',
                    'error',
                    'Downgrading to 3, pblt: ' +
                      (ref.playbackStartLatency + ref.thresholdAbovePBSLForDowngrade) +
                      ', piscs: ' +
                      playingInSameChannelSinceSec +
                      ', at: ' +
                      ref.getCurrTime()
                  );
                  // send event to stats service
                  ref.logClientVideoStatsJSON('DG');
                  ref.storePlayerDetails();
                  ref.targetChannel = ref.currentChannel + 1;
                  ref.adaptBitrate(true, undefined as unknown as number, false);
                  // ref.adaptBitrate(true, this.targetChannel, false);
                  ref.consecutiveUVS = 0;
                }
                ref.playVideo();
                if (ref.video.seekable.length > 0 && ref.video.seekable.end(0) <= 3) {
                  ref.latency = parseFloat((ref.video.seekable.end(0) - ref.video.currentTime).toFixed(2));
                }
              }
            }
            if (!ref.isVideoStarted) {
              ref.isVideoStarted = true;
              // window.parent.window.postMessage({ "type": "notifyVideoLoaded" }, "*");
            }
            if (ref.videoVolume > 0 && ref.isStageInteraction) {
              ref.video.muted = false;
            }
          }
        }
      });
    } else {
      ref.logClientVideoStatsJSON('MN');
    }
    this.isPlayerStarted = true;
  }

  playVideo() {
    var playPromise = this.video.play();
    if (playPromise !== undefined) {
      playPromise.then((_) => {
        this.video.play();
      });
    } else {
      this.logClientVideoStatsJSON('VE');
      this.resetBandwidth();
      if (this.mediaSource?.readyState === 'open') {
        this.buffer?.abort();
      }
      this.clearMediaSourceEventListeners();
      this.resetVideoPlayback();
    }
  }

  onSourceEnded() {
    this.logClientVideoStatsJSON('MC');
    if (this.currentChannel < 3) {
      this.currentChannel = this.currentChannel + 1;
    }
    if (this.buffer && this.mediaSource) {
      try {
        this.mediaSource.removeSourceBuffer(this.buffer);
      } catch (e) {
        //nothing we can do;
      }
    }
    this.clearMediaSourceEventListeners();
    this.resetVideoPlayback();
  }

  onSourceClose() {
    this.clearMediaSourceEventListeners();
  }

  clearMediaSourceEventListeners() {
    if (this.mediaSource) {
      this.mediaSource.removeEventListener('sourceopen', this.sourceBufferHandle.bind(this));
      this.mediaSource.removeEventListener('sourceended', this.onSourceEnded.bind(this));
      this.mediaSource.removeEventListener('sourcebuffererror', this.onSourceBufferError.bind(this));
      this.video.removeEventListener('error', this.handleVideoError.bind(this));
      this.mediaSource.removeEventListener('sourceclose', this.onSourceClose.bind(this));
    }
  }

  onSourceBufferError() {
    // console.log("MediaSource error when appending buffer: " + event.target.error.code + ": " + event.target.error.message + ", at: " + this.getCurrTime());
    this.logClientVideoStatsJSON('SE');
  }

  initWS() {
    var ref = this;
    try {
      if (this.isVideoPausedinGame) {
        return;
      }
      if (this.reconnectingTimer) {
        clearInterval(this.reconnectingTimer);
        this.reconnectingTimer = null;
      }
      this.ws = new WebSocket(this.path);
      this.lastWssConnectionAttemptedAt = Date.now();
      this.ws.binaryType = 'arraybuffer';

      this.ws.onopen = function () {
        ////console.info("New webSocket initialised, ccnl: " + ref.currentChannel + ", at:" + ref.getCurrTime());
        // send event to stats service
        ref.logClientVideoStatsJSON('CW');
        ref.playingInSameChannelSince[ref.currentChannel] = Date.now();
        if (!ref.firstPingBasedRTTChecked) {
          ref.checkPingBasedRTT();
        }
      };

      this.ws.addEventListener('message', this.onWebSocketMessage.bind(this));

      this.ws.onclose = function () {
        if (ref.isVideoPausedinGame) return;
        var lastWssConnectionAttemptedOnCloseAt = Date.now() - ref.lastWssConnectionAttemptedAt;
        if (!ref.ws && lastWssConnectionAttemptedOnCloseAt > 30000) {
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'WebSocket is closed, reseting player, at: ' + ref.getCurrTime()
          );
          // send event to stats service
          ref.logClientVideoStatsJSON('WC');
          ref.resetVideoPlayback();
        }
        if (!ref.isVideoStarted) {
          ref.ws = null;
          // window.parent.window.postMessage({ "type": "notifyClassicViewChange", "visible": true }, "*");

          ref.reconnectingTimer && window.clearInterval(ref.reconnectingTimer);
          ref.reconnectingTimer = window.setInterval(function () {
            if (!ref.ws) ref.initWS();
          }, ref.reconnectingTimerEvery);
        }
      };

      this.ws.onerror = function (e) {
        Logger.logInfo('VideoPlayerLogger', 'error', 'ws error: ' + e + ', at: ' + ref.getCurrTime());
        ref.logClientVideoStatsJSON('WE');
      };
    } catch (e) {
      Logger.logInfo('VideoPlayerLogger', 'error', 'WebSocket Error: ' + e + ', at: ' + this.getCurrTime());
      this.reconnectingTimer && window.clearInterval(this.reconnectingTimer);
      this.reconnectingTimer = window.setInterval(function () {
        if (!ref.ws) ref.initWS();
      }, this.reconnectingTimerEvery);

      ref.logClientVideoStatsJSON('WE');
    }
  }

  processMoov() {
    let isMoov =
      this.bufferInputData &&
      this.bufferInputData[4] == 102 &&
      this.bufferInputData[5] == 116 &&
      this.bufferInputData[6] == 121 &&
      this.bufferInputData[7] == 112;
    if (isMoov) {
      this.playbackStartTime = Date.now();
      this.resetBandwidth();
      this.isChannelChanging = false;
    }
  }

  populateSourceBuffer(bufferInputData: BufferSource) {
    try {
      this.buffer?.appendBuffer(bufferInputData);
    } catch (e) {
      Logger.logInfo('VideoPlayerLogger', 'error', 'Appending buffer error, at: ' + this.getCurrTime());
      // send event to stats service
      this.logClientVideoStatsJSON('AE');
      if (e instanceof DOMException && e.name === 'QuotaExceededError') {
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Appending buffer error, quota exceeded. Reseting buffer and establishing new websocket, at: ' +
            this.getCurrTime()
        );
        // send event to stats service
        this.logClientVideoStatsJSON('AE');
        this.resetBandwidth();
        if (this.mediaSource?.readyState === 'open') {
          this.buffer?.abort();
        }
        this.clearMediaSourceEventListeners();
        this.resetVideoPlayback();
      }
    }
  }

  // VideoComponent.prototype.resolveVideoPlayback = function () {
  //   if (this.video.seekable.length > 0) {
  //     if (this.video.seekable.end(0) >= this.playbackStartLatency && !this.isVideoPlaying()) {
  //       if (this.video.paused) {
  //         this.playVideo();
  //         if (this.video.seekable.end(0) <= 3) {
  //           this.latency = parseFloat((parseFloat(this.video.seekable.end(0)) - parseFloat(this.video.currentTime)).toFixed(2));
  //         }
  //       }
  //       if (!this.isVideoStarted) {
  //         this.isVideoStarted = true;
  //         window.parent.window.postMessage({ "type": "notifyVideoLoaded" }, "*");
  //       }
  //       this.video.hidden = false;
  //       if (this.videoVolume > 0 && this.isStageInteraction && this.video.muted) {
  //         this.video.muted = false;
  //       }
  //     }
  //   }
  // };

  processWSSCommand(event: MessageEvent) {
    var cmd = JSON.parse(event.data);
    switch (cmd.cmd) {
      case 'reset':
        break;
      case 'conn':
      case 'connected':
        if (this.ws?.readyState == WebSocket.OPEN) {
          this.ws.send('iq' + this.currentChannel);
          this.ws.send('quality' + this.currentChannel);
        }
        this.wssResetCount++;
        // this.lastWssReset = Date.now();
        break;
      case 'pong':
        this.pingReturnCounter = cmd.counter;
        var pingTime = cmd.clientTime;
        var pongTime = +new Date();
        if (this.pingReturnCounter === this.pingCounter) {
          this.pingPongDelay = pongTime - pingTime;
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Ping RTT: ' + this.pingPongDelay + ', at: ' + this.getCurrTime()
          );
          // send event to stats service
        } else {
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Abnormal ping-pong response, pc: ' +
              this.pingCounter +
              ', prc: ' +
              this.pingReturnCounter +
              ', at: ' +
              this.getCurrTime()
          );
          // send event to stats service
          this.logClientVideoStatsJSON('AP');
        }
        break;
      default:
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Unknown command received from server, cmd: ' + cmd + ', at: ' + this.getCurrTime()
        );
        // send event to stats service
        this.logClientVideoStatsJSON('UC');
        break;
    }
  }

  populateRealLatency() {
    if (this.queue.length <= 0) {
      this.realLatency = this.latency;
    } else {
      this.realLatency = this.latency + (this.queue.length * this.packetDuration) / 1000.0;
    }
  }

  decideWssResetBasedOnRealLatency() {
    if (this.realLatency > this.criticalQueueHighLatency && this.queue.length > 0 && this.isInitPlaybackStarted) {
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Real latency exceeded, re-connecting websocket, rl: ' +
          this.realLatency +
          ', buf: ' +
          this.latency +
          ', ql: ' +
          this.queue.length +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('RE');
      if (
        this.hardCapBadChannelForUpgrade[0] &&
        this.hardCapBadChannelForUpgrade[1] &&
        this.hardCapBadChannelForUpgrade[2]
      ) {
        this.adaptBitrate(false, 3, false);
      } else if (
        this.hardCapBadChannelForUpgrade[0] &&
        this.hardCapBadChannelForUpgrade[1] &&
        !this.hardCapBadChannelForUpgrade[2]
      ) {
        this.adaptBitrate(false, 2, false);
      } else if (this.hardCapBadChannelForUpgrade[0] && !this.hardCapBadChannelForUpgrade[1]) {
        this.adaptBitrate(false, 1, false);
      } else if (!this.hardCapBadChannelForUpgrade[0]) {
        this.adaptBitrate(false, 0, false);
      } else {
        this.adaptBitrate(false, this.currentChannel, false);
      }
    }
  }

  onWebSocketMessage(event: MessageEvent) {
    if (typeof event.data === 'object') {
      this.lastPacketReceivedAt = Date.now();
      if (this.isVideoStopped && !this.isInitBandWidth) {
        return;
      }
      if (this.isVideoPausedinGame && !this.buffer) {
        return;
      }

      this.populateRealLatency();
      this.decideWssResetBasedOnRealLatency();
      this.bufferInputData = new Uint8Array(event.data);
      this.bandwidthBasedABRInputData.push({ ts: Date.now(), bytes: this.bufferInputData.byteLength });
      this.processMoov();
      this.queue.push(this.bufferInputData);
      this.video.hidden = false;
      this.updateBuffer();
      this.checkAndSetQueueBasedChannelUpgradeHardCap();
      //this.resolveVideoPlayback();
    } else {
      this.processWSSCommand(event);
    }
  }

  updateAndNotifyLatency() {
    if (this.latencyIntervalRef) {
      clearInterval(this.latencyIntervalRef);
      this.latencyIntervalRef = null;
    }
    this.latencyIntervalRef = window.setInterval(() => {
      if (this.video.seekable.length > 0 && this.isVideoPlaying()) {
        this.latency = this.video.seekable.end(0) - this.video.currentTime;
        this.latencyListeners.forEach((listener) => listener(parseFloat((this.latency * 1000).toFixed(2))));
      }
    }, 3000);
  }

  getCurrTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const milliseconds = now.getMilliseconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}:${milliseconds}`;
  }

  createObjectURL(object: MediaSource): string {
    return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
  }

  getLatencyRange(latency: number) {
    if (latency <= 0.3) return 1;
    else if (latency > 0.3 && latency <= 1.2) return 2;
    else if (latency > 1.2 && latency <= 1.7) return 3;
    else if (latency > 1.7 && latency <= 2.0) return 4;
    else if (latency > 2.0 && latency <= 2.6) return 5;
    else if (latency > 2.6 && latency <= 3) return 6;
    else if (latency > 3 && latency <= 3.5) return 7;
    else if (latency > 3.5) return 8;
    else return -1;
  }

  private initVideoPlayback(): void {
    this.currentChannel = this.startUpChannel;
    this.initWebsocketPlayer();
    this.playingInSameChannelSince[this.currentChannel] = Date.now();
    this.channelSwitchInCount[this.currentChannel] = this.channelSwitchInCount[this.currentChannel] + 1;
    this.isInitBandWidth = true;
  }

  private trimVideo(): void {
    if (this.latency >= this.criticalHighLatency) {
      let currentTime = Date.now();
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Current latency is ' +
          this.latency +
          ', removed latency ' +
          (this.latency - this.trimCriticalHighLatency).toFixed(2) +
          ' secs, at: ' +
          this.getCurrTime()
      );
      if (this.video.seekable.length > 0) {
        this.setVideoCurrentTime(this.video.seekable.end(0) - this.trimCriticalHighLatency);
      }
      this.latency = this.trimCriticalHighLatency;

      // send event to stats service
      let lastTrimmedLatencyAtSec = 0;
      if (this.lastTrimmedLatencyAt !== null) {
        lastTrimmedLatencyAtSec = (currentTime - this.lastTrimmedLatencyAt) / 1000.0;
      }
      if (lastTrimmedLatencyAtSec === 0 || lastTrimmedLatencyAtSec > 2) {
        this.logClientVideoStatsJSON('TL');
      }
      this.lastTrimmedLatencyAt = currentTime;
    }
  }

  private notifyCurrentLatency(): void {
    let currentTime = Date.now();
    if (currentTime - this.latencyUpdatedTime > this.notifyLatencyEvery * 1000) {
      this.latencyUpdatedTime = currentTime;
      // if (this.latency > 0) {
      //   window.parent.window.postMessage({ "type": "notifyVideoLatency", "latency": parseFloat(((this.latency + 0.75) * 1000).toFixed(0)) }, "*");
      // } else {
      //   window.parent.window.postMessage({ "type": "notifyVideoLatency", "latency": 750 }, "*");
      // }
    }
  }

  private updateBuffer(): void {
    if (!this.buffer) return;

    this.isPlayerStarted = true;
    if (this.mediaSource?.readyState === 'open' && this.buffer && !this.buffer.updating && this.queue.length > 0) {
      this.populateSourceBuffer(this.queue.shift() as Uint8Array);
    }
    if (this.video.seekable.length > 0 && this.video.currentTime > 0) {
      this.latency = parseFloat((this.video.seekable.end(0) - this.video.currentTime).toFixed(2));
      // @ts-ignore
      this.playingInSameChannelSinceMs = Date.now() - this.playingInSameChannelSince[this.currentChannel];
      if (this.playingInSameChannelSinceMs <= 80) {
        this.lastBufferSnapshot = this.latency;
      }
      this.trimVideo();
      this.notifyCurrentLatency();
    } else if (this.video.seekable.length > 0 && this.video.readyState > 0 && !this.isVideoPlaying()) {
      if (this.video.seekable.end(0) > this.playbackStartLatency) {
        this.setVideoCurrentTime(this.video.seekable.end(0) - this.playbackStartLatency);
      }
    }
  }

  private isVideoPlaying(): boolean {
    return this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2;
  }

  private resetPlayer(): void {
    if (this.latency <= this.criticalLowLatency) {
      this.logClientVideoStatsJSON('CL');
    }

    if (this.switchClassicviewTimeout) {
      clearTimeout(this.switchClassicviewTimeout);
    }

    // window.parent.window.postMessage({ "type": "notifyVideoLatency", "latency": (this.playbackStartLatency * 1000) }, "*");
    const currentTime = Date.now();

    this.isChannelChanging = true;
    this.pingPongDelay = 0;
    this.buffer = null;
    this.bufferInputData = null;
    this.lastPacketReceivedAt = currentTime;
    this.isPlayerStarted = false;
    this.queue = [];
    this.latencyByDecreasedPlaybackRate = [0.0, 0.0, 0.0, 0.0];
    this.isInitBandWidth = false;
    this.latency = 0;
    this.realLatency = 0;
    this.isChannelChanging = false;
    this.isInitPlaybackStarted = false;
    this.latencyUpdatedTime = currentTime;
    this.lastImprovedStableUpgrade[this.currentChannel] = this.playingInSameChannelSince[this.currentChannel] =
      currentTime;
    this.channelSwitchInCount[this.currentChannel] = this.channelSwitchInCount[this.currentChannel] + 1;
    this.pingCounter = 0;
    this.pingReturnCounter = 0;

    this.isVideoWaitingTime = null;
    this.playbackStartTime = null;

    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }

    if (this.reconnectingTimer) {
      clearInterval(this.reconnectingTimer);
      this.reconnectingTimer = null;
    }
  }

  private setVideoCurrentTime(currentTime: number): void {
    if (currentTime > 0 && currentTime < Number.MAX_SAFE_INTEGER) {
      this.video.currentTime = currentTime;
    }
  }

  private checkCapUpgradeForWssReset(currentTime: number): void {
    this.lastWssResetForUpgradeCapSec = 0;
    let hasSetHcbcfupg = false;

    if (this.wssResetCount % this.setLastWssResetForUpgradeCapFrequency === 0) {
      this.lastWssResetForUpgradeCapSec = (currentTime - this.lastWssResetForUpgradeCap) / 1000.0;
      if (
        this.channelSwitchInCount[0] > 0 &&
        !this.hardCapBadChannelForUpgrade[0] &&
        this.totalPlaybackTime[0] <= this.capUpgradeForWssResetThreshold &&
        !this.hasBeenBestChannelToPlay[0]
      ) {
        this.hardCapBadChannelForUpgrade[0] = true;
      } else if (
        this.channelSwitchInCount[0] === 0 &&
        this.channelSwitchInCount[1] > 0 &&
        !this.hardCapBadChannelForUpgrade[1] &&
        this.totalPlaybackTime[1] <= this.capUpgradeForWssResetThreshold &&
        !this.hasBeenBestChannelToPlay[1]
      ) {
        this.hardCapBadChannelForUpgrade[1] = true;
        this.hardCapBadChannelForUpgrade[0] = true;
      } else if (
        this.channelSwitchInCount[0] === 0 &&
        this.channelSwitchInCount[1] === 0 &&
        this.channelSwitchInCount[2] > 0 &&
        !this.hardCapBadChannelForUpgrade[2] &&
        this.totalPlaybackTime[2] <= this.capUpgradeForWssResetThreshold &&
        !this.hasBeenBestChannelToPlay[2]
      ) {
        this.hardCapBadChannelForUpgrade[2] = true;
        this.hardCapBadChannelForUpgrade[1] = true;
        this.hardCapBadChannelForUpgrade[0] = true;
      } else if (
        this.channelSwitchInCount[0] === 0 &&
        this.channelSwitchInCount[1] === 0 &&
        this.channelSwitchInCount[2] === 0 &&
        this.channelSwitchInCount[3] > 0 &&
        !this.hardCapBadChannelForUpgrade[3] &&
        this.totalPlaybackTime[3] <= this.capUpgradeForWssResetThreshold &&
        !this.hasBeenBestChannelToPlay[3]
      ) {
        this.hardCapBadChannelForUpgrade[3] = true;
        this.hardCapBadChannelForUpgrade[2] = true;
        this.hardCapBadChannelForUpgrade[1] = true;
        this.hardCapBadChannelForUpgrade[0] = true;
      }
      hasSetHcbcfupg = true;
    }

    if (hasSetHcbcfupg) {
      // hasSetHcbcfupg = false;
      this.lastWssResetForUpgradeCap = currentTime;
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Setting hcbcfupg: ' +
          this.hardCapBadChannelForUpgrade +
          ', wrc: ' +
          this.wssResetCount +
          ', lwrfucs: ' +
          this.lastWssResetForUpgradeCapSec +
          ', tpbktbyc: ' +
          this.totalPlaybackTime +
          ', csic: ' +
          this.channelSwitchInCount +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('SH');
    }
  }

  public onVolumeChange(volume: number): void {
    this.videoVolume = volume;
    if (this.video) {
      this.video.volume = this.videoVolume;
      this.video.muted = !this.isStageInteraction || this.videoVolume <= 0;
    }
  }

  public onChannelChanged(data: number | 'auto'): void {
    Logger.logInfo(
      'VideoPlayerLogger',
      'error',
      'Channel is manually changed to: ' + data + ', at:' + this.getCurrTime()
    );
    // send event to stats service
    if (this.isPlayerStarted) {
      if (data == 0) {
        if (this.currentChannel != 0) this.onChannel1Selected();
        this.isAutoChannel = false;
      } else if (data == 1) {
        if (this.currentChannel != 1) this.onChannel2Selected();
        this.isAutoChannel = false;
      } else if (data == 2) {
        if (this.currentChannel != 2) this.onChannel3Selected();
        this.isAutoChannel = false;
      } else if (data == 3) {
        if (this.currentChannel != 3) this.onChannel4Selected();
        this.isAutoChannel = false;
      } else if (data == 'auto') {
        this.onAutoChannelSelected();
        this.isAutoChannel = true;
      }
      this.logClientVideoStatsJSON('MG');
      if (this.video.playbackRate !== 1) {
        this.video.playbackRate = 1;
      }
    } else {
      if (data == 'auto') {
        this.isAutoChannel = true;
      } else {
        this.isAutoChannel = false;
        this.currentChannel = data;
      }
    }
  }

  onChannel1Selected() {
    this.currentChannel = 0;
    this.ShiftChannel();
  }

  onChannel2Selected() {
    this.currentChannel = 1;
    this.ShiftChannel();
  }

  onChannel3Selected() {
    this.currentChannel = 2;
    this.ShiftChannel();
  }

  onChannel4Selected() {
    this.currentChannel = 3;
    this.ShiftChannel();
  }

  onAutoChannelSelected() {
    this.isAutoChannel = true;
  }

  resetVideoPlayback() {
    this.resetPlayer();
    this.initWebsocketPlayer();
  }

  ShiftChannel() {
    if (this.ws?.readyState == WebSocket.OPEN) {
      this.ws.send('qcreq' + this.currentChannel);
      this.ws.send('quality' + this.currentChannel);
    }

    this.isChannelChanging = true;
    this.decideClassicViewSwitch();
  }

  calculateTotalPbkTimeByChannel() {
    let totPbkTimeByChannel = [0, 0, 0, 0];
    totPbkTimeByChannel[0] = this.totalPlaybackTime[0];
    totPbkTimeByChannel[1] = this.totalPlaybackTime[1];
    totPbkTimeByChannel[2] = this.totalPlaybackTime[2];
    totPbkTimeByChannel[3] = this.totalPlaybackTime[3];
    totPbkTimeByChannel[this.currentChannel] =
      // @ts-ignore
      totPbkTimeByChannel[this.currentChannel] + (Date.now() - this.playingInSameChannelSince[this.currentChannel]);
    return totPbkTimeByChannel;
  }

  checkGoodChannelForUpgrade(targetChannel: number) {
    this.targetChannel = targetChannel;
    if (this.channelUpgradeInSameWSAfterStartCUVSCount[this.targetChannel] < 0) {
      return;
    }
    // let appLaunchedSince = (Date.now() - this.appLaunched) / 1000.00;
    let totalPbkTimeByChannel = this.calculateTotalPbkTimeByChannel();
    let lastTrimmedLatencySec = 0;
    let markBadChannelForUpgrade = false;
    if (this.lastTrimmedLatencyAt !== null) {
      lastTrimmedLatencySec = (Date.now() - this.lastTrimmedLatencyAt) / 1000.0;
    }

    if (this.negativeBufferBurnedNoDomino[this.targetChannel]) {
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Bad upgrade for channel: ' + this.targetChannel + ', reason: NEG_BUFF_BURN_RATE, at: ' + this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('NB');
      markBadChannelForUpgrade = true;
    } else if (this.consecutiveUVS > this.consecutiveUVSForUpgrade) {
      let cuvsUpgradeAttemptStartSince = (Date.now() - this.cuvsUpgradeAttemptStart) / 1000.0;
      if (
        cuvsUpgradeAttemptStartSince > this.cuvsUpgradeThreshold &&
        (lastTrimmedLatencySec === 0 || lastTrimmedLatencySec >= this.cuvsUpgradeThreshold)
      ) {
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Bad upgrade for channel: ' + this.targetChannel + ', reason: SLOW_BUFFER_BUILD, at: ' + this.getCurrTime()
        );
        // send event to stats service
        if (this.reasonForBadChannelUpgrade !== 'SB') {
          this.reasonForBadChannelUpgrade = 'SB';
          this.logClientVideoStatsJSON('SB');
        }
        markBadChannelForUpgrade = true;
      }
    } else if (
      totalPbkTimeByChannel[this.targetChannel] > 0 &&
      parseFloat(
        ((totalPbkTimeByChannel[this.targetChannel] * 100.0) / totalPbkTimeByChannel[this.currentChannel]).toFixed(2)
      ) < this.badChannelMinPlaybackPctRequiredForUpgrade
    ) {
      markBadChannelForUpgrade = true;
      for (let i = this.targetChannel; i >= 0; i--) {
        if (
          totalPbkTimeByChannel[i] > 0 &&
          parseFloat(((totalPbkTimeByChannel[i] * 100.0) / totalPbkTimeByChannel[this.currentChannel]).toFixed(2)) >=
            this.badChannelMinPlaybackPctRequiredForUpgrade
        ) {
          markBadChannelForUpgrade = false;
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Bad upgrade for channel, reason: LESS_PLAYTIME_IN_TARGET_CHANNEL overridden. Higher channel has better playback, at: ' +
              this.getCurrTime()
          );
          // send event to stats service
          if (this.reasonForBadChannelUpgrade !== 'LO') {
            this.reasonForBadChannelUpgrade = 'LO';
            this.logClientVideoStatsJSON('LO');
          }
        }
      }
      if (markBadChannelForUpgrade) {
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Bad upgrade for channel: ' +
            this.targetChannel +
            ', tpbkbyc: ' +
            totalPbkTimeByChannel +
            ', reason: LESS_PLAYTIME_IN_TARGET_CHANNEL, at: ' +
            this.getCurrTime()
        );
        // send event to stats service
        if (this.reasonForBadChannelUpgrade !== 'LP') {
          this.reasonForBadChannelUpgrade = 'LP';
          this.logClientVideoStatsJSON('LP');
        }
      }
    }

    if (markBadChannelForUpgrade) {
      for (let i = this.targetChannel; i >= 0; i--) {
        this.goodChannelForUpgrade[i] = false;
      }
    }
  }

  private fineTunePlayBackRate(videoPlaybackRateChangeFactor: number): void {
    if (this.latency > this.playbackOptimalLatencyRange[1]) {
      if (this.currentChannel > 0 || (this.currentChannel === 0 && this.bestChannelToPlay === this.currentChannel)) {
        this.video.playbackRate = this.defaultVideoPlaybackRate + videoPlaybackRateChangeFactor;
        Logger.logInfo(
          'VideoPlayerLogger',
          'error',
          'Fine-tuning pbrt, speeding up, for ccnl: ' +
            this.currentChannel +
            ', buf: ' +
            this.latency +
            ', pbkrt: ' +
            this.video.playbackRate +
            ', at: ' +
            this.getCurrTime()
        );
        // send event to stats service
      }
    } else if (this.latency < this.playbackOptimalLatencyRange[0]) {
      this.video.playbackRate = this.defaultVideoPlaybackRate - videoPlaybackRateChangeFactor;
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Fine-tuning pbrt, slowing down, for ccnl: ' +
          this.currentChannel +
          ', buf: ' +
          this.latency +
          ', pbkrt: ' +
          this.video.playbackRate +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
    } else if (
      this.latency >= this.playbackOptimalLatencyRange[0] &&
      this.latency <= this.playbackOptimalLatencyRange[1]
    ) {
      this.video.playbackRate = this.defaultVideoPlaybackRate;
    }
  }

  private adaptInNewWebSocket(targetChannel: number): void {
    this.targetChannel = targetChannel;
    if (this.currentChannel !== this.targetChannel) {
      this.checkLowBandwidthForPopup();
    }
    this.adjustVideoPlayback(this.defaultVideoPlaybackRate, 0);
    this.consecutiveUVS = 0;
    this.totalPlaybackTime[this.currentChannel] =
      // @ts-ignore
      this.totalPlaybackTime[this.currentChannel] + (Date.now() - this.playingInSameChannelSince[this.currentChannel]);
    if (this.currentChannel !== this.targetChannel) {
      this.channelSwitchInCount[this.targetChannel] = this.channelSwitchInCount[this.targetChannel] + 1;
    }
    this.currentChannel = this.targetChannel;
    Logger.logInfo(
      'VideoPlayerLogger',
      'error',
      'Change video in new websocket, buffer: ' +
        this.latency +
        ', from chl: ' +
        this.currentChannel +
        ', to chl: ' +
        this.targetChannel +
        ', at: ' +
        this.getCurrTime()
    );
    this.checkCapUpgradeForWssReset(Date.now());
    this.resetVideoPlayback();
  }

  private checkCapUpgradeC0ForAdaptDownInSameWebSocket(currentTime: number): void {
    // @ts-ignore
    let lastC0UpgradeSec = (currentTime - this.lastUpgraded[0]) / 1000.0;
    if (lastC0UpgradeSec <= this.lastC0UpgradeThresholdForC0HardCapCheck) {
      this.ccuc0fadiswssCount++;
    }
    if (this.ccuc0fadiswssCount >= this.ccuc0fadiswssCountThreshold && !this.hardCapBadChannelForUpgrade[0]) {
      this.hardCapBadChannelForUpgrade[0] = true;
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Setting hcbcfupg for C0: ' + this.hardCapBadChannelForUpgrade + ', at: ' + this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('SH');
    }
  }

  private adaptDownInSameWebSocket(targetChannel: number, forceBitRateChange: boolean): void {
    this.targetChannel = targetChannel;
    let secsinCurrentChannel = 0;
    let currentTime = Date.now();
    let playingInSameChannelSinceElement = this.playingInSameChannelSince[this.currentChannel];
    if (playingInSameChannelSinceElement !== null) {
      secsinCurrentChannel = (currentTime - playingInSameChannelSinceElement) / 1000.0;
    }
    if (
      secsinCurrentChannel === 0 ||
      secsinCurrentChannel > 3 ||
      this.latency < this.lowLatency ||
      forceBitRateChange ||
      (this.currentChannel === 0 && this.latency <= 2)
    ) {
      this.latencyByDecreasedPlaybackRate[this.currentChannel] = 0;
      this.consecutiveUVS = 0;
      this.totalPlaybackTime[this.currentChannel] =
        // @ts-ignore
        this.totalPlaybackTime[this.currentChannel] + (currentTime - playingInSameChannelSinceElement);
      this.playingInSameChannelSince[this.targetChannel] = currentTime;
      this.updateUpgradeIncreaseFactor(this.targetChannel);
      if (this.targetChannel === 3) {
        this.checkCapUpgradeC0ForAdaptDownInSameWebSocket(currentTime);
      }
      this.prevChannelForCUVS = this.currentChannel;
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Change video in same websocket, buffer: ' +
          this.latency +
          ', from chl: ' +
          this.currentChannel +
          ', to chl: ' +
          this.targetChannel +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('DG');
      this.storePlayerDetails();
      this.currentChannel = this.targetChannel;
      this.channelSwitchInCount[this.currentChannel] = this.channelSwitchInCount[this.currentChannel] + 1;
      this.ShiftChannel();
      this.lastImprovedStableUpgrade[this.currentChannel] = currentTime;
    }
  }

  private adaptUpInSameWebSocket(targetChannel: number, forceBitRateChange: boolean): void {
    if (this.pingPongDelay > this.minRTTToConsiderForUpgrade) return;

    this.targetChannel = targetChannel;
    let currentTime = Date.now();
    this.latencyByDecreasedPlaybackRate[this.currentChannel] = 0;
    let appLaunchedSince = (currentTime - this.appLaunched) / 1000.0;
    if (!forceBitRateChange) {
      this.checkGoodChannelForUpgrade(this.targetChannel);
    }
    let secsinCurrentChannel = 0;
    let playingInSameChannelSinceElement = this.playingInSameChannelSince[this.currentChannel];
    if (playingInSameChannelSinceElement !== null && appLaunchedSince >= this.startConsecutiveUVS) {
      secsinCurrentChannel = (currentTime - playingInSameChannelSinceElement) / 1000.0;
    }

    this.calculateBenchmarkBandwidth(this.targetChannel);
    if (
      (secsinCurrentChannel === 0 ||
        forceBitRateChange ||
        (!this.hasBeenBestChannelToPlay[this.targetChannel] &&
          this.consecutiveUVS > this.consecutiveUVSForUpgrade &&
          this.goodChannelForUpgrade[this.targetChannel] &&
          this.bwRateChangeThresholdToConsiderForUpgrade[this.currentChannel] <
            this.bwRateChangeThresholdToConsiderForUpgradeBase +
              this.bwRateChangeThresholdToConsiderForUpgradeIncreaseFactor * 2) ||
        (this.hasBeenBestChannelToPlay[this.targetChannel] &&
          this.consecutiveUVS > this.consecutiveUVSForUpgrade &&
          this.goodChannelForUpgrade[this.targetChannel] &&
          this.clientBandwidth >= this.benchmarkBandwidth)) &&
      !this.hardCapBadChannelForUpgrade[this.targetChannel]
    ) {
      // upgrade in the same websocket
      Logger.logInfo(
        'VideoPlayerLogger',
        'error',
        'Change video in same websocket, buffer: ' +
          this.latency +
          ', sicc: ' +
          secsinCurrentChannel +
          ', from chl: ' +
          this.currentChannel +
          ', to chl: ' +
          this.targetChannel +
          ', at: ' +
          this.getCurrTime()
      );
      // send event to stats service
      this.logClientVideoStatsJSON('UG');
      this.storePlayerDetails();
      this.consecutiveUVS = 0;
      this.totalPlaybackTime[this.currentChannel] =
        // @ts-ignore
        this.totalPlaybackTime[this.currentChannel] + (currentTime - playingInSameChannelSinceElement);
      this.playingInSameChannelSince[this.targetChannel] = currentTime;
      this.prevChannelForCUVS = this.currentChannel;
      this.currentChannel = this.targetChannel;
      this.channelSwitchInCount[this.currentChannel] = this.channelSwitchInCount[this.currentChannel] + 1;
      if (secsinCurrentChannel > 0) {
        this.channelUpgradeInSameWSAfterStartCUVSCount[this.currentChannel] =
          this.channelUpgradeInSameWSAfterStartCUVSCount[this.currentChannel] + 1;
      }
      this.ShiftChannel();
      this.lastUpgraded[this.currentChannel] = currentTime;
      this.lastImprovedStableUpgrade[this.currentChannel] = currentTime;
    } else if (!this.goodChannelForUpgrade[this.targetChannel]) {
      this.fineTunePlayBackRate(this.videoPlaybackRateChangeFactor);
    }
  }

  private adaptBitrate(changeInSameChannel: boolean, targetChannel: number, forceBitRateChange: boolean): void {
    this.targetChannel = targetChannel;
    if (this.targetChannel > 3) this.targetChannel = 3;
    if (this.targetChannel < 0) this.targetChannel = 0;
    if (this.currentChannel === this.targetChannel && changeInSameChannel) {
      return;
    }

    if (!changeInSameChannel) {
      // upgrading or downgrading in new websocket
      this.adaptInNewWebSocket(this.targetChannel);
    } else {
      if (this.targetChannel < this.currentChannel) {
        // upgrading in the same websocket
        this.adaptUpInSameWebSocket(this.targetChannel, forceBitRateChange);
      } else if (this.targetChannel > this.currentChannel) {
        // downgrading in the same websocket
        this.adaptDownInSameWebSocket(this.targetChannel, forceBitRateChange);
      }
    }
  }

  private updateUpgradeIncreaseFactor(targetChannel: number): void {
    this.targetChannel = targetChannel;
    let currentTime = Date.now();
    let lastUpgradedSec = 0;
    let lastUpgradedElement = this.lastUpgraded[this.currentChannel];
    if (lastUpgradedElement !== null) {
      lastUpgradedSec = (currentTime - lastUpgradedElement) / 1000.0;
    }
    let lastUpdateUpgradeIncreaseFactorChangedSec = 0;
    if (this.lastUpdateUpgradeIncreaseFactorChanged !== null) {
      lastUpdateUpgradeIncreaseFactorChangedSec = (currentTime - this.lastUpdateUpgradeIncreaseFactorChanged) / 1000.0;
    }
    let appLaunchedSec = (currentTime - this.appLaunched) / 1000.0;
    if (lastUpgradedSec > 0) {
      if (
        lastUpdateUpgradeIncreaseFactorChangedSec === 0 ||
        lastUpdateUpgradeIncreaseFactorChangedSec > this.lastUpdateUpgradeIncreaseFactorThreshold ||
        appLaunchedSec <= this.lastUpdateUpgradeIncreaseFactorThreshold
      ) {
        if (!this.hasBeenBestChannelToPlay[this.currentChannel]) {
          this.bwRateChangeThresholdToConsiderForUpgrade[this.targetChannel] =
            this.bwRateChangeThresholdToConsiderForUpgrade[this.targetChannel] +
            this.bwRateChangeThresholdToConsiderForUpgradeIncreaseFactor;
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Increasing brcttcfu for channel: ' +
              this.targetChannel +
              ', luuifcs: ' +
              lastUpdateUpgradeIncreaseFactorChangedSec +
              ', at: ' +
              this.getCurrTime()
          );
          // send event to stats service
          this.logClientVideoStatsJSON('IB');
        } else {
          this.bandwidthAtChannelUpgrade[this.currentChannel] =
            this.bandwidthAtChannelUpgrade[this.currentChannel] +
            this.bandwidthAtChannelUpgrade[this.currentChannel] *
              this.bwRateChangeThresholdToConsiderForUpgradeIncreaseFactor;
          Logger.logInfo(
            'VideoPlayerLogger',
            'error',
            'Increasing bacupg for channel: ' +
              this.currentChannel +
              ', luuifcs: ' +
              lastUpdateUpgradeIncreaseFactorChangedSec +
              ', at: ' +
              this.getCurrTime()
          );
          // send event to stats service
          this.logClientVideoStatsJSON('IU');
        }
        this.lastUpdateUpgradeIncreaseFactorChanged = currentTime;
      }
    }
  }

  decideClassicViewSwitch() {
    if (this.isAutoChannel && this.currentChannel > 1) {
      if (this.switchClassicviewTimeout) {
        clearTimeout(this.switchClassicviewTimeout);
      }
      this.switchClassicviewTimeout = window.setTimeout(() => {
        if (this.currentChannel === 3) {
          if (!this.switchClassicView) {
            this.switchClassicView = true;
            if (this.classicViewSwitcher) {
              this.classicViewSwitcher(true);
            }
            this.logClientVideoStatsJSON('CI');
          }
        } else {
          if (this.switchClassicView) {
            this.switchClassicView = false;
            if (this.classicViewSwitcher) {
              this.classicViewSwitcher(false);
            }
            this.logClientVideoStatsJSON('CO');
          }
        }
      }, this.switchClassicviewTimeoutDuration);
    }
  }

  logClientVideoStatsJSON(eventType: string) {
    if (this.bandWidthImprovedRecently && eventType !== 'BI') {
      this.bandWidthImprovedRecently = false;
    }
    let videoStatsJSON = {
      etid: eventType,
      uid: this.uuid,
      jid: '',
      tid: '',
      etu: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
      etl: Date.now(),
      wurl: this.streamName,
      ipc: this.inputCode ? this.inputCode : 0,
      ac: this.actionCode,
      ccl: this.currentChannel,
      tcl: this.targetChannel,
      bw: this.clientBandwidth,
      bbw: this.benchmarkBandwidth,
      bfu0: this.bwRateChangeThresholdToConsiderForUpgrade[0],
      bfu1: this.bwRateChangeThresholdToConsiderForUpgrade[1],
      bfu2: this.bwRateChangeThresholdToConsiderForUpgrade[2],
      bfu3: this.bwRateChangeThresholdToConsiderForUpgrade[3],
      bup0: this.bandwidthAtChannelUpgrade[0],
      bup1: this.bandwidthAtChannelUpgrade[1],
      bup2: this.bandwidthAtChannelUpgrade[2],
      bup3: this.bandwidthAtChannelUpgrade[3],
      buf: isFinite(this.latency) && !isNaN(this.latency) ? this.latency.toFixed(2) : 0.0,
      cuvs: this.consecutiveUVS,
      pcuvs: this.prevChannelForCUVS,
      ql: this.queue.length,
      pbrt: this.video.playbackRate,
      cuc0: this.channelUpgradeInSameWSAfterStartCUVSCount[0],
      cuc1: this.channelUpgradeInSameWSAfterStartCUVSCount[1],
      cuc2: this.channelUpgradeInSameWSAfterStartCUVSCount[2],
      cuc3: this.channelUpgradeInSameWSAfterStartCUVSCount[3],
      csc0: this.channelSwitchInCount[0],
      csc1: this.channelSwitchInCount[1],
      csc2: this.channelSwitchInCount[2],
      csc3: this.channelSwitchInCount[3],
      tpt0: this.currentChannel !== 0 ? this.totalPlaybackTime[0] : this.totalPlaybackTime[0] + this.currentPBKTime,
      tpt1: this.currentChannel !== 1 ? this.totalPlaybackTime[1] : this.totalPlaybackTime[1] + this.currentPBKTime,
      tpt2: this.currentChannel !== 2 ? this.totalPlaybackTime[2] : this.totalPlaybackTime[2] + this.currentPBKTime,
      tpt3: this.currentChannel !== 3 ? this.totalPlaybackTime[3] : this.totalPlaybackTime[3] + this.currentPBKTime,
      tpts: isFinite(this.totPBKTimeSec) && !isNaN(this.totPBKTimeSec) ? this.totPBKTimeSec.toFixed(2) : 0.0,
      pss: this.playingInSameChannelSinceMs,
      bcp: this.bestChannelToPlay,
      gcu0: this.goodChannelForUpgrade[0] ? 1 : 0,
      gcu1: this.goodChannelForUpgrade[1] ? 1 : 0,
      gcu2: this.goodChannelForUpgrade[2] ? 1 : 0,
      gcu3: this.goodChannelForUpgrade[3] ? 1 : 0,
      hbc0: this.hasBeenBestChannelToPlay[0] ? 1 : 0,
      hbc1: this.hasBeenBestChannelToPlay[1] ? 1 : 0,
      hbc2: this.hasBeenBestChannelToPlay[2] ? 1 : 0,
      hbc3: this.hasBeenBestChannelToPlay[3] ? 1 : 0,
      ldp0:
        isFinite(this.latencyByDecreasedPlaybackRate[0]) && !isNaN(this.latencyByDecreasedPlaybackRate[0])
          ? this.latencyByDecreasedPlaybackRate[0].toFixed(2)
          : 0.0,
      ldp1:
        isFinite(this.latencyByDecreasedPlaybackRate[1]) && !isNaN(this.latencyByDecreasedPlaybackRate[1])
          ? this.latencyByDecreasedPlaybackRate[1].toFixed(2)
          : 0.0,
      ldp2:
        isFinite(this.latencyByDecreasedPlaybackRate[2]) && !isNaN(this.latencyByDecreasedPlaybackRate[2])
          ? this.latencyByDecreasedPlaybackRate[2].toFixed(2)
          : 0.0,
      ldp3:
        isFinite(this.latencyByDecreasedPlaybackRate[3]) && !isNaN(this.latencyByDecreasedPlaybackRate[3])
          ? this.latencyByDecreasedPlaybackRate[3].toFixed(2)
          : 0.0,
      bbr: isFinite(this.bufferBurnRate) && !isNaN(this.bufferBurnRate) ? this.bufferBurnRate.toFixed(2) : 0.0,
      nbr0: this.negativeBufferBurnRateCount[0],
      nbr1: this.negativeBufferBurnRateCount[1],
      nbr2: this.negativeBufferBurnRateCount[2],
      nbr3: this.negativeBufferBurnRateCount[3],
      lbs:
        isFinite(this.lastBufferSnapshot) && !isNaN(this.lastBufferSnapshot) ? this.lastBufferSnapshot.toFixed(2) : 0.0,
      lps: this.lastVideoPlaybackRateSnapshot,
      lnb: this.lastNegativeBufferBurnedAt,
      ltl: this.lastTrimmedLatencyAt,
      lup0: this.lastUpgraded[0],
      lup1: this.lastUpgraded[1],
      lup2: this.lastUpgraded[2],
      lup3: this.lastUpgraded[3],
      hcu0: this.hardCapBadChannelForUpgrade[0] ? 1 : 0,
      hcu1: this.hardCapBadChannelForUpgrade[1] ? 1 : 0,
      hcu2: this.hardCapBadChannelForUpgrade[2] ? 1 : 0,
      hcu3: this.hardCapBadChannelForUpgrade[3] ? 1 : 0,
      wrc: this.wssResetCount,
      lru: this.lastWssResetForUpgradeCapSec.toFixed(2),
      rtt: this.pingPongDelay,
      mn1: eventType === 'VE' ? this.videoErrorCode : null,
      mn2: eventType === 'WS' ? (this.isVideoWaitingTime ? Date.now() - this.isVideoWaitingTime : 0) : 0,
      mc1: this.isAutoChannel,
    };

    if (this.statsLogger) {
      this.statsLogger({ event: VideoStatsEvent.VideoPlaybackDetails, data: videoStatsJSON });
    }
  }

  storePlayerDetails() {
    if (!this.storeVLQ) return;
    let playerStatsJSON = {
      lastPlayedChannel: this.currentChannel,
      tpbkt0:
        this.currentChannel !== 0
          ? this.totalPlaybackTime[0] / 1000
          : (this.totalPlaybackTime[0] + this.currentPBKTime) / 1000,
      tpbkt1:
        this.currentChannel !== 1
          ? this.totalPlaybackTime[1] / 1000
          : (this.totalPlaybackTime[1] + this.currentPBKTime) / 1000,
      tpbkt2:
        this.currentChannel !== 2
          ? this.totalPlaybackTime[2] / 1000
          : (this.totalPlaybackTime[2] + this.currentPBKTime) / 1000,
      tpbkt3:
        this.currentChannel !== 3
          ? this.totalPlaybackTime[3] / 1000
          : (this.totalPlaybackTime[3] + this.currentPBKTime) / 1000,
      dpbkt0: this.currentChannel === 0 ? this.currentPBKTime / 1000 : 0,
      dpbkt1: this.currentChannel === 1 ? this.currentPBKTime / 1000 : 0,
      dpbkt2: this.currentChannel === 2 ? this.currentPBKTime / 1000 : 0,
      dpbkt3: this.currentChannel === 3 ? this.currentPBKTime / 1000 : 0,
    };
    if (this.statsLogger) {
      this.statsLogger({ event: VideoStatsEvent.StorePlayerDetails, data: playerStatsJSON });
    }
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 3) | 8;
      return v.toString(16);
    });
  }

  setLogger(logger: Function): void {
    this.statsLogger = logger;
  }

  setClassicViewSwitcher(switcher: Function): void {
    this.classicViewSwitcher = switcher;
  }
  setStatsBasedQuality(startUpChannel: number) {
    if (this.startUpChannel !== startUpChannel) {
      this.currentChannel = startUpChannel;
      this.ShiftChannel();
    }
  }

  setStoreVLQ(storeVLQ: boolean): void {
    this.storeVLQ = storeVLQ;
  }

  getChannelLimit(): number {
    return this.targetChannel;
  }
}
